import React, { memo } from 'react';

import { BannerInformation } from 'components/bannerInformation';
import { LiveNav } from '../liveNav/LiveNav';
import { SportsInfoScommessaPreMatch } from 'types/swagger';
import classNames from 'classnames';
import { selectIsOpenCarrello } from 'features/carrello/carrelloSelectors';
import styles from './LiveInternalLayout.module.scss';
import { useTypedSelector } from 'lib/centralStore';

export type LiveInternalLayoutProps = {
  children?: React.ReactNode;
  noPaddingTop?: boolean; // TODO capire se serve
  hasStreaming?: boolean;
  scommessaPreMatch?: SportsInfoScommessaPreMatch;
  hasNoPaddingOnMain?: boolean; // TODO capire se serve
};

export const LiveInternalLayout = memo(function LiveInternalLayout({
  children,
  noPaddingTop,
}: LiveInternalLayoutProps) {
  const errori = useTypedSelector((root) => root.sportTicket.errori);
  const isOpen = useTypedSelector(selectIsOpenCarrello);
  const errorsLabels = useTypedSelector((root) => root.carrello.errorsLabels);

  return (
    <div
      className={classNames(styles.container, {
        [styles.noPaddingTop]: noPaddingTop,
        [styles.open]: isOpen,
      })}
    >
      <LiveNav />
      <div className={styles.childrenContainer}>
        {errori.erroreInserimento && (
          <BannerInformation
            text={
              [errorsLabels.find((errorLabel) => errorLabel.key === errori.erroreInserimento)][0]?.value ||
              errori.erroreInserimento
            }
            type="warning"
            layoutType="big"
            visible={errori.erroreInserimento ? true : false}
          />
        )}
        {children}
      </div>
    </div>
  );
});
